import { useCallback, useState } from 'react';

export default function useUserInteraction(onUserInteraction) {
  const [lastUserInteraction, setLastUserInteraction] = useState(Date.now());

  const handleUserInteraction = useCallback(() => {
    setLastUserInteraction(Date.now());
    if (onUserInteraction) onUserInteraction();
  }, [onUserInteraction]);

  return {
    lastUserInteraction,
    handleUserInteraction,
  };
}
